"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBAPIDocsMenu", {
  enumerable: true,
  get: function get() {
    return _src.default;
  }
});
Object.defineProperty(exports, "SidebarItem", {
  enumerable: true,
  get: function get() {
    return _SubMenus.default;
  }
});
Object.defineProperty(exports, "methodSpan", {
  enumerable: true,
  get: function get() {
    return _SubMenus.methodSpan;
  }
});
var _src = _interopRequireDefault(require("./src"));
var _SubMenus = _interopRequireWildcard(require("./src/js/SubMenus"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }